module.exports = __webpack_public_path__ + "static/media/lori-avila.43199da8.jpg";